import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import SideNavLayout from "../customsidenav/sidenavlayout"
import { faSearch } from "@fortawesome/free-solid-svg-icons"
import UsersTable from "./userstable"
import AddIcon from '@mui/icons-material/Add';
import { MenuItem, Select, FormControl, InputLabel, Backdrop, CircularProgress } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useEffect, useState } from "react";
import api from "../api/api";
import AddnewUser from "./AddnewUser";
import ReactPaginate from "react-paginate";
import { filtericonsvg } from "./svg";
import FilterByRoleModal from "./filtermodal";
const UserTab=()=>{
    const [selected, setSelected] = useState("5");
    const [addnewUser, setaddnewUser] = useState(false);
    const [sortOrder,setSortOrder]=useState('desc')
    const [showRoleFilter, setShowRoleFilter] = useState(false);
const [appliedRoles, setAppliedRoles] = useState([]);
const [lastActiveSort, setLastActiveSort] = useState("desc"); 

// /v1/{{practiceid}}/users
const [currentPage, setCurrentPage] = useState(0);
      const [users, setUsers] = useState([]);  // State to store the user data
  const [loading, setLoading] = useState(false);  // Loading state to show the loading indicator
  const [searchQuery, setSearchQuery] = useState(""); 
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [imagesdata,setImageData]=useState([]) 
    const practiseid = window.getPracticeId();
    const [sortColumn, setSortColumn] = useState("status");

  // Fetch user data
   const getStatus = (item) => {
    const status = item.status?.trim().toUpperCase();
    const locked = item.locked_status?.trim().toUpperCase();

    if (status === "I") return "Inactive";
    if (locked === "I") return "Locked";
    return "Active";
  };

  const fetchUsersData = async () => {
    setLoading(true);  // Start loading
  
    // Ensure the practice ID is correct
   
    console.log("Practice ID:", practiseid); // Log to check the practice ID
  
    try {
      const response = await api.get(`/v1/${practiseid}/users`);  // Fetch users for the specific practice ID
      if (response.status === 200) {
        setUsers(response.data);  // Set the user data
      } else {
        setUsers([]);  // Clear users if response isn't successful
      }
    } catch (error) {
      console.error('Error fetching users:', error.response || error.message || error);
      setUsers([]);  // Clear users in case of error
    } finally {
      setLoading(false);  // Stop loading
    }
  };
  const fetchimgs=async()=>{
    try {
      const response = await api.get(`/v1/${practiseid}/users/profile-pictures`)
 
      if(response.status==200){
     
        setImageData(response?.data||[])
      }else{
        setImageData([])
      }
    } catch (error) {
      console.log(error)
    }
  }

  // Use effect or event to trigger the fetch function (example)
  useEffect(() => {
    document.title = "CHIM - User Management";
    fetchUsersData();
    fetchimgs()

  }, []);  // Dependency

  const handleChange = (event) => {
    setSelected(event.target.value);
  };
  
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(0);
  };

const uploadimg = async ({file,id}) => {
  try {
    console.log(id)
    const formData = new FormData();
    formData.append("file", file);
    const upload = await api.post(
      `/v1/${practiseid}/user/${id}/upload-profile-picture`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    if (upload.status === 200) {
      fetchimgs()
      fetchUsersData(true); // Refresh profile
    }
  } catch (error) {
    console.log(error);
  }
};
  const AddnewModalClose=()=>{
   setaddnewUser(false)
  }

  const handlePageClick = (event) => {
    setCurrentPage(event.selected);
  };
  // FILTER USERS
const filteredUsers = users
  .filter((u) => {
    const fullName = `${u.firstname} ${u.lastname}`.toLowerCase();
    const username = u.username.toLowerCase();
    const q = searchQuery.toLowerCase();

    const roleMatch =
      appliedRoles.length === 0 ||
      appliedRoles.includes(u.rolename?.trim());

    return (fullName.includes(q) || username.includes(q)) && roleMatch;
  });

  // SORTING PRIORITY
  const priority = { Active: 3, Locked: 2, Inactive: 1 };

  // SORT USERS BEFORE PAGINATION
const sortedUsers = [...filteredUsers].sort((a, b) => {
  const statusA = priority[getStatus(a)];
  const statusB = priority[getStatus(b)];

  const dateA = new Date(a.last_login || 0).getTime();
  const dateB = new Date(b.last_login || 0).getTime();

  // 🟦 CASE 1: Sorting by STATUS first, then Last Active
  if (sortColumn === "status") {
    // Primary: Status
    const primary = sortOrder === "asc"
      ? statusA - statusB
      : statusB - statusA;

    if (primary !== 0) return primary;

    // Secondary: Last Active
    return lastActiveSort === "asc" ? dateA - dateB : dateB - dateA;
  }

  // 🟩 CASE 2: Sorting by LAST ACTIVE first, then Status
  if (sortColumn === "last_active") {
    // Primary: Last Active
    const primary = lastActiveSort === "asc"
      ? dateA - dateB
      : dateB - dateA;

    if (primary !== 0) return primary;

    // Secondary: Status
    return sortOrder === "asc"
      ? statusA - statusB
      : statusB - statusA;
  }

  return 0;
});

  // PAGINATION
  const currentUsers = sortedUsers.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage
  );
const endIndex = Math.min(
    (currentPage + 1) * itemsPerPage,
    filteredUsers.length
  );
  const startIndex = currentPage * itemsPerPage + 1;
  useEffect(() => {
    setCurrentPage(0);
  }, [itemsPerPage]);
  const changestatus=async(user)=>{
  try {
    setLoading(true)
       const payload ={
            "rowid": user.id,
            "practiceid":practiseid,
             "email":user.email,
            "status": user.status === "A" ? "I" : "A",
       
        }
         const response = await api.put(`/v1/${practiseid}/user`, payload);
  } catch (error) {
    console.log(error)
  }finally{
    setLoading(false)
    fetchUsersData()
  }
}

    return(
    <>
     <div className="h-full">
    <SideNavLayout>
    <div className="w-full flex justify-end">
                        <div className="relative w-full max-w-md">
                            <div className="flex items-center w-[80%] bg-[#F5F6FA] border border-[#D5D5D5] rounded-[15px]">
                                {/* Left-aligned search icon inside the input field */}
                                <FontAwesomeIcon
                                    icon={faSearch}
                                    className="text-gray-400 ml-3"
                                />
                                {/* Search input field with reduced height */}
                                <input
                                   value={searchQuery}
                                   onChange={handleSearchChange}
                                    type="text"
                                    className="bg-[#F5F6FA] flex-grow py-1 pl-2 pr-3 text-base outline-none rounded-[15px]"
                                    placeholder="Search"
                                /> 
                            </div>
                        </div>
                    </div>    
<div className="flex justify-between m-4">
<div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
    <span>Show</span> {/* Text before the dropdown */}
    <select
                className="ml-2 border p-1 rounded-md text-sm"
                onChange={(e) => setItemsPerPage(Number(e.target.value))}
                value={itemsPerPage}
              >
                <option value="10">10</option>
                <option value="20">25</option>
                <option value="30">50</option>
                <option value="50">100</option>
    </select>
    <span>Entries</span> {/* Text after the dropdown */}

   <div className="cursor-pointer" onClick={() => setShowRoleFilter(true)}>
  {filtericonsvg}
</div>

</div>

<button
    className="rounded-full py-1 px-3 text-[12px] bg-[#1D2951] flex items-center font-inter text-white shadow-md max-w-[160px] truncate"
    onClick={() => setaddnewUser(true)} // Add this line to open the modal
>
    <AddIcon className="mr-1" style={{width:'18px'}}/> Add New User
</button>

</div>
<div>{appliedRoles.length > 0 && (
  <div className="flex flex-wrap gap-2 mb-3 px-4">
    {appliedRoles.map((role, index) => (
      <div
        key={index}
        className="flex items-center bg-blue-100 text-blue-700   px-3 py-1 rounded-full text-sm"
      >
        {role}
        <button
          className="ml-2 font-bold"
          onClick={() =>
            setAppliedRoles((prev) => prev.filter((r) => r !== role))
          }
        >
          ×
        </button>
      </div>
    ))}
  </div>
)}
</div>
                    <div className="w-full flex mt-4 justify-center">

                        <UsersTable changestatus={changestatus} setSortOrder={setSortOrder} sortOrder={sortOrder} 
                          sortColumn={sortColumn}
  setSortColumn={setSortColumn}

  lastActiveSort={lastActiveSort}
  setLastActiveSort={setLastActiveSort}
                        onFileChange={uploadimg} users={currentUsers} fetchUsersData={fetchUsersData} imagesdata={imagesdata}/>
                        </div>
                        <div className="mt-4 flex justify-between px-10">
                {/* Displaying dynamic range of entries */}
                <span className="text-sm text-[#6B7280] text-[14px]">
                  Showing {startIndex} to {endIndex} of {filteredUsers.length} entries
                </span>
                <div className=" flex gap-4 items-center">
                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
    <span>per page</span> {/* Text before the dropdown */}
    <select
                className="ml-2 border p-1 rounded-md text-sm"
                onChange={(e) => setItemsPerPage(Number(e.target.value))}
                value={itemsPerPage}
              >
                <option value="10">10</option>
                <option value="20">25</option>
                <option value="30">50</option>
                <option value="50">100</option>
    </select>
  
</div>

<ReactPaginate
  previousLabel={
    <div className="px-3 py-[6px] border text-sm mr-1 rounded text-black">
      Previous
    </div>
  }
  nextLabel={
    <div className="px-3 py-[6px] border text-sm ml-1 rounded text-black">
      Next
    </div>
  }

  pageCount={Math.ceil(filteredUsers.length / itemsPerPage)}
  onPageChange={handlePageClick}

  // 🔥 SHOW ONLY ONE PAGE ALWAYS
  pageRangeDisplayed={1}
  marginPagesDisplayed={0}
  breakLabel={null}
  breakClassName={"hidden"}

  forcePage={currentPage}
  renderOnZeroPageCount={null}

  containerClassName={"pagination flex items-center gap-2"}
  activeClassName={"active-page"}
  pageClassName={"page-item"}
  pageLinkClassName={
    "page-link px-3 py-2 border rounded-md text-black cursor-pointer"
  }
/>


<style>{`
  .pagination .page-link {
    background-color: #1D2951 !important;
    border-color: #1D2951 !important;
    color: white !important;
  }

  .pagination .page-link:hover {
    background-color: #32406b !important; /* Slightly lighter hover */
  }

  .pagination .active-page .page-link {
    background-color: #32406b !important;
    border-color: #32406b !important;
    color: #fff !important;
  }
      /* Hide all page numbers */
  .pagination .page-item {
    display: none !important;
  }

  /* Show ONLY the active page */
  .pagination .active-page {
    display: block !important;
  }

  /* Also hide break (...) symbols if any */
  .pagination .break-me {
    display: none !important;
  }
`}</style>

                </div>
           

              </div>
        </SideNavLayout>
{showRoleFilter && (
  <FilterByRoleModal
    users={users}
    appliedRoles={appliedRoles}
    onApply={(roles) => setAppliedRoles(roles)}
    onClose={() => setShowRoleFilter(false)}
  />
)}

        <Backdrop
                       sx={{
                         color: 'secondary.main', // Sets the CircularProgress color to secondary
                         backgroundColor: 'rgba(255, 255, 255, 0.5)', // Semi-transparent white background
                         zIndex: (theme) => theme.zIndex.drawer + 1
                       }}
                       open={loading}
                     >
                       <CircularProgress color="secondary" />
                     </Backdrop>
               {addnewUser&&<AddnewUser uploadimg={uploadimg} fetchUsersData={fetchUsersData} AddnewModalClose={AddnewModalClose}/>}      
     </div>
    
    
    </>)
}
export default UserTab